import { Box, BoxProps } from "@mui/material";
import { FC } from "react";

export const ContractFormWrapper: FC<BoxProps> = ({ children, ...props }) => {
  return (
    <Box
      {...props}
      sx={{
        ...props.sx,
        height: "100%",
        backgroundColor: (theme) => theme.palette.grey[100],
        px: 4,
        py: 4,
        overflow: "auto",
      }}
    >
      {children}
    </Box>
  );
};
